import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-product-avatar',
  templateUrl: './product-avatar.component.html',
  styleUrls: ['./product-avatar.component.scss']
})
export class ProductAvatarComponent {

  @Input() media: string | undefined;

  loading: boolean = true;

  onLoad() {
    this.loading = false;
  }

  getImage() {
    return this.media ? this.media : '../../../assets/images/placeholder_star.svg';
  }

  onError() {
    this.media = '../../../assets/images/placeholder_star.svg';
  }

}
